<template>
    <div class="spe_detail">
        <div class="f-row">
            <Breadcrumb separator=">" class="breadcrumb_zdy">
                当前位置:
                <BreadcrumbItem :to="{name: 'SpecialList'}">专题Pro</BreadcrumbItem>
                <BreadcrumbItem>快讯推荐列表页</BreadcrumbItem>
            </Breadcrumb>
            <div>
                <!-- <a href="javascript:history.go(-1)" ><i class="iconfont-sm">&#xe661;</i> 返回上一级页面</a> -->
            </div>
        </div>
        <div class="spe_list">
            <div
                v-for = "item,index in month"
                :key = "index"
                class = "spe_item"
            >
                <div class="date">
                    <div>
                        <p>{{item | time_moment('YYYY')}}</p>
                        <p>{{item | time_moment('M')}}月</p>
                    </div>
                </div>
                <div class="list">
                    <table>
                        <tr
                            v-for = "item2,index2 in topic_lsit[item]"
                            :key = "index2"
                        >
                            <td>
                                <a
                                    class = "topic_title"
                                    @click = "goDetail(item2.uid)"
                                >
                                    <!-- <span
                                        class="tag"
                                        v-for="(item3, idx) in item2.type_arr"
                                        :key="idx"
                                    >{{item3 | deal('news_topic_type')}}</span> -->
                                    {{item2.title}}
                                </a>
                            </td>
                            <td width="340">
                                {{item2.create_time | time_moment('YYYY-MM-DD HH:mm')}}
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="list_bottom">
                <button
                    class="more_btn"
                    @click="haddleMore()"
                    v-if="len == 10"
                >加载更多</button>
            </div>
        </div>
    </div>
</template>
<script>
import { themeNewsTopic, addPuv } from '../../service'
import moment from 'moment'

export default {
  data() {
    return {
      page: 1,
      new_topic: [],
      len: 0
    }
  },
  computed: {
    params_uid() {
      return this.$route.params.uid
    },
    month() {
      let month = []
      this.new_topic.map((a) => {
        let m = moment(a.create_time).format('YYYY-MM')
        let index = month.findIndex((b) => b == m)
        if (index == -1) month.push(m)
      })
      return month
    },
    topic_lsit() {
      let topic_lsit = {}
      this.month.map((a) => topic_lsit[a] = [] )
      this.new_topic.map((a) => {
        let m = moment(a.create_time).format('YYYY-MM')
        topic_lsit[m].push(a)
      })
      return topic_lsit
    },
    user_key() {
      return this.$store.state.user_key
    }
  },
  methods: {
    async getSpecialNewsList() {
      let params = {
        page: this.page,
        theme_id: this.params_uid
      }
      let res = await themeNewsTopic(params, (error) => this.$Message.error('请求错误！'))
      if(res.status == 'success') {
        res.res.map((a) => {
          this.new_topic.push(a)
        })
        this.len = res.res.length
      } else {
        this.$Message.error(res.message)
      }
    },
    haddleMore() {
      this.page ++
      this.getSpecialNewsList()
    },
    goDetail(uid) {
      const href = this.$store.state.index2_path + '/newsDetail/' + uid
      window.open(href, "_blank");
    },
    async getAddPuv() {
      let puv_params = {
        user_key: this.user_key,
        url: window.location.href,
        row_id: ''
      }
      let res = await addPuv(puv_params, (error) => this.$Message.error('请求错误！'))
    }
  },
  created() {
    this.getSpecialNewsList()
    this.getAddPuv()
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
.spe_detail
  padding: 16px 0 30px
  width: 1200px
  margin: 0 auto
  .spe_list
    padding-top: 20px
  .spe_item
    display: flex
    &+.spe_item
      margin-top: 30px
    .date
      flex: 0 0 60px
      > div
        display: inline-block
        vertical-align: top
        width: 60px
        height: 66px
        commonBgImg('~pic/month_bg.png', '~pic/month_bg2.png')
        background-size: 100% !important
        padding-top: 18px
        line-height: 1
        p
          text-align: center
          color: rgba(255,255,255,.5)
          font-size: 12px
          &+p
            color: rgba(255,255,255,1)
            font-weight: 600
            font-size: 20px
            margin-top: 2px
    .list
      flex: auto
      margin-left: 30px
      table
        width: 100%
        th
          height: 50px
          background: #2A2F42
          color: #fff
          text-align: left
          padding-left: 40px
          font-size: 16px
          font-weight: bold
        td
          height: 50px
          padding: 13px 0 13px 40px
          commonBgColor(#1f2330, #ffffff)
          border-bottom: 1px solid
          commonBorderColor(#2A2F42, #F3F3F3)
          font-size: 14px
          commonColor(#e9e9eb, #999999)
          a
            color: #E9E9EB
            commonColor(#ffffff, #666666)
            line-height: 20px
            display: inline-block
            vertical-align: top
            span
              display: inline-block
              vertical-align: top
              &+span
                margin-left: 10px
              &:last-of-type
                margin-right: 21px
                position: relative
                &:before
                  content: ''
                  position: absolute
                  width: 1px
                  height: 14px
                  background-color: #40444f
                  right: -11px
                  top: 3px
            &:hover
              color: rgba(250, 122, 80, 1)
        tr:last-child td
          border-bottom: 0
  .list_bottom
    text-align: center
    .more_btn
      border: 1px solid rgba(250, 122, 80, 1)
      margin-top: 30px
      border-radius: 18px
      display: inline-block
      width: 108px
      height: 36px
      background: transparent
      color: rgba(250, 122, 80, 1)
      cursor: pointer
      &:hover
        color: #FC9C7C
        border-color: #FC9C7C
</style>
